import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ImpersonationService {
  isImpersonatedSession = false;

  setImpersonated(value: boolean) {
    this.isImpersonatedSession = value;
  }
}
